export default "__VITE_ASSET__QNjJ6UR3__"